export default {
  catalog: 'Catalog',
  articles: 'Articles',
  faq: 'FAQ',
};
